import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import '../styles.less'
import CancelProjectWidget from '../../../widgets/closeProject/CancelProjectWidget'
import CancelProjectHistoryWidget from '../../../widgets/closeProject/CancelProjectHistoryWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import AgreementAdditionalWidgets from '../../../widgets/agreementAdditional/AgreementAdditionalWidgets'
import { getCancelForm } from '../../../redux/actions/cancelOfProject'

export default function CancelProjectStaff(props) {
  const [isLoading, setIsLoading] = useState(false)
  const [schemas, setSchemas] = useState()
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    projectId && handleGetSchema(projectId)
    //setSchemas(mockSchema.model)
  }, [projectId])

  const handleGetSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getCancelForm(proposalId)
      if (response.success) setSchemas(response.model)
    } catch (e) {
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleOnDownloadFile = async (id, fileName) => {
    startLoading()
    try {
      const file = await downlondDocument(projectId, id)
      downloadFile(file, fileName)
    } catch (err) {
      notification.open('error', {
        title: 'ดาวน์โหลดเอกสารไม่สำเร็จ',
      })
    }
    doneLoading()
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schemas || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal>
        <ContentHeader header={schemas.header} subHeader={schemas.subHeader} />
        {schemas?.forms?.agreementDetails && (
          <AgreementAdditionalWidgets formSchema={schemas.forms.agreementDetails} />
        )}
        {schemas?.forms?.requestNote && (
          <>
            <CancelProjectWidget
              showCommandButton={!schemas.forms.requestNote.disabled}
              schema={schemas.forms.requestNote}
              attachmentSchema={schemas.forms.attachment}
            />
            <br />
          </>
        )}
        {schemas?.forms?.cancelProjectHistory && (
          <>
            <CancelProjectHistoryWidget
              data={schemas.forms.cancelProjectHistory.value}
              header={schemas.forms.cancelProjectHistory.header}
              onSuccess={() => handleGetSchema(projectId)}
              schemaButton={schemas.forms}
            />
            <br />
          </>
        )}
      </SidebarProposal>
    </>
  )
}

const mockSchema = {
  affectedRows: 0,
  message: 'Successfully',
  success: true,
  didError: false,
  errorMessage: null,
  model: {
    header: 'ยกเลิกการให้ทุนสนับสนุนโครงการ',
    subHeader: 'ข้อเสนอโครงการ เด็กฉลาด ทดสอบแก้ไขหลังทำสัญญา 1',
    forms: {
      agreementDetails: null,
      requestNote: {
        header: 'ยกเลิกการให้ทุนสนับสนุนโครงการ',
        buttonText: 'เสนอเจ้าหน้าที่ศูนย์สัญญาพิจารณา',
        note: {
          name: 'Note',
          label: 'ความคิดเห็น',
          value: null,
          hint: 'ระบุความคิดเห็น',
          validators: [
            {
              type: 'REQUIRED',
              value: null,
              errorMessage: 'โปรดระบุ ความคิดเห็น',
            },
          ],
        },
      },
      attachment: {
        name: 'Attachments',
        label: 'เอกสารแนบประกอบการพิจารณา',
        value: null,
      },
      fileList: [],
      cancelProjectHistory: {
        header: 'ประวัติการยกเลิกการให้ทุนสนับสนุนโครงการ',
        value: null,
      },
    },
  },
}
